import { asyncStart } from '../../common/index';

export const GET_ACCELERATED_TESTERS = 'acceleratedTesters.getAcceleratedTesters';
export const getAcceleratedTesters = (snapshotYear) => (dispatch) => {
  dispatch(asyncStart(GET_ACCELERATED_TESTERS));
  dispatch({
    type: GET_ACCELERATED_TESTERS,
    snapshotYear,
  });
};

export const UPDATE_ACCELERATED_TESTER_OVERRIDE = 'acceleratedTesters.updateAcceleratedTesterOverride';
export const updateAcceleratedTesterOverride = (snapshotYear, firebaseId, override) => (dispatch) => {
  dispatch(asyncStart(UPDATE_ACCELERATED_TESTER_OVERRIDE));
  dispatch({
    type: UPDATE_ACCELERATED_TESTER_OVERRIDE,
    snapshotYear,
    firebaseId,
    override,
  });
};

export const UPDATE_ACCELERATED_TESTER_OVERRIDES_BULK = 'acceleratedTesters.updateAcceleratedTesterOverridesBulk';
export const updateAcceleratedTesterOverridesBulk = (snapshotYear, updates) => (dispatch) => {
  dispatch(asyncStart(UPDATE_ACCELERATED_TESTER_OVERRIDES_BULK));
  dispatch({
    type: UPDATE_ACCELERATED_TESTER_OVERRIDES_BULK,
    snapshotYear,
    updates,
  });
};

export const UPLOAD_ACCELERATED_TESTERS_FILE = 'acceleratedTesters.uploadFile';
export const uploadAcceleratedTestersFile = (profile, file, snapshotYear) => (dispatch) => {
  dispatch(asyncStart(UPLOAD_ACCELERATED_TESTERS_FILE));
  dispatch({
    type: UPLOAD_ACCELERATED_TESTERS_FILE,
    profile,
    file,
    snapshotYear,
  });
};
